export const CREATE_COMPANY = "CREATE_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const STORE_COMPANIES = "STORE_COMPANIES";
export const LIST_COMPANIES = "LIST_COMPANIES";